import { AgxDivider, AgxRow, AgxTab } from '@urbanx/agx.ui-components2';
import { TeamPageTabs } from './TeamPageTabs';
import { useCallback, useMemo } from 'react';
import { TeamPageTabOptions } from './TeamPageTabOptions';
import { useNavigate } from 'react-router-dom';
import { Pages } from 'constants/menu';
import useAgencyIdParam from 'hooks/useAgencyIdParam';

interface TeamPageHeaderProps {
  actionButtons?: React.ReactNode;
  selectedTab: TeamPageTabs;
  agencyId?: string;
}

const getPathForTab = (tab: TeamPageTabs, agencyId: string) => {
  const basePath = `/${Pages.AGENCIES}/${agencyId}/${Pages.TEAMS}`;

  switch (tab) {
    case TeamPageTabs.TeamMembers:
      return `${basePath}/${Pages.TEAMS_MEMBERS}`;
    case TeamPageTabs.ManageTeams:
      return `${basePath}/${Pages.TEAMS_MANAGE_TEAMS}`;
    case TeamPageTabs.UrbanXTeam:
      return `${basePath}/${Pages.TEAMS_URBANX_TEAM}`;
    default:
      return basePath;
  }
};

const TeamPageHeader = ({ actionButtons, selectedTab }: TeamPageHeaderProps) => {
  const agencyId = useAgencyIdParam();

  const tabOptions = useMemo(() => {
    return TeamPageTabOptions.map((tab) => ({
      ...tab,
      selected: selectedTab === tab.id,
    }));
  }, [selectedTab]);

  const navigate = useNavigate();

  const changeTab = useCallback(
    (tabId: TeamPageTabs) => {
      if (!agencyId) return;

      navigate(getPathForTab(tabId, agencyId));
    },
    [navigate, agencyId]
  );

  return (
    <>
      <AgxRow fill justifyContent="space-between" alignItems="alignCenter">
        <AgxTab
          options={tabOptions}
          onChange={(tab) => {
            if (tab.id === selectedTab) return;

            changeTab(tab.id as TeamPageTabs);
          }}
        />
        {actionButtons}
      </AgxRow>
      <AgxDivider variant="horizontal" />
    </>
  );
};

export default TeamPageHeader;
